import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappButton = () => {

  const whatsappNumber = "919755897963"; 
  const message = "Hi! I want to know more about your courses.";

  return (
    <>
        <a
          href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
            message
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-6 right-6 z-50 bg-green-500 p-4 rounded-full shadow-lg hover:bg-green-600 transition-all"
        >
          <FaWhatsapp className="text-white text-2xl" />
        </a>
    </>
  );
};

export default WhatsappButton;
